<template>
  <v-dialog v-model="isOpen" persistent max-width="640px">
    <div class="position-relative">
      <v-card>
        <v-card-title class="justify-content-center">
          <span>{{ isUpdate ? translations('common.update') : translations('common.create_new') }}</span>
        </v-card-title>
        <v-card-text>
          <span>{{ translations('shipping_instruction.title') }}</span>
          <input v-model="title" type="text" class="form-control input-title-document" maxlength="20">
        </v-card-text>
        <v-card-text>
          <span>{{ translations('shipping_instruction.content') }}</span>
          <v-textarea v-model="description" outlined hide-details></v-textarea>
        </v-card-text>
        <v-card-actions class="pb-6 px-6 justify-content-between">
          <button
            type="button"
            class="btn btn-secondary mr-1"
            @click="close"
            >
            {{ translations('common.close') }}
            </button>
            <button v-if="!isUpdate" type="button" class="btn btn-primary" @click="addDocument">{{ translations('common.keep') }}</button>
            <button v-else type="button" class="btn btn-primary" @click="updateDocument">{{ translations('common.keep') }}</button>
        </v-card-actions>
      </v-card>
      <loading-component :is-loading="isLoading"/>
    </div>
  </v-dialog>
</template>

<script>
import LoadingComponent from './loading/LoadingComponent.vue'
import _isEmpty from 'lodash/isEmpty'
import { mapState } from 'vuex'

export default {
  name: 'DocumentFormModal',
  props: {
    isUpdate: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    document: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    LoadingComponent
  },
  watch: {
    document: {
      handler: function (val) {
        if (!_isEmpty(val)) {
          this.title = val.title
          this.description = val.description
          this.documentId = Number(val.id)
        } else if (!this.isUpdate) {
          this.title = ''
          this.description = ''
        }
      },
      deep: true
    }
  },
  data () {
    return {
      isLoading: false,
      title: '',
      description: '',
      documentId: 0
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    init () {
      this.title = ''
      this.description = ''
    },
    async addDocument () {
      this.isLoading = true
      try {
        const params = {
          title: this.title,
          description: this.description
        }
        const { data: { status, message } } = await this.$http.post(this.$api_url.create_template_shipping_instruction, params)
        if (status) {
          this.$toastr.success(this.translations('shipping_instruction.notice_creation_completed'), this.translations('common.success'))
          this.init()
          this.$emit('close', false, true)
        } else {
          this.$toastr.error(message, this.translations('common.error'))
        }
      } catch (error) {}
      this.isLoading = false
    },
    async updateDocument () {
      this.isLoading = true
      try {
        const params = {
          title: this.title,
          description: this.description
        }
        const { data: { status, message } } = await this.$http.post(this.$api_url.update_template_shipping_instruction + this.documentId, params)
        if (status) {
          this.$toastr.success(this.translations('shipping_instruction.notice_update_completed'), this.translations('common.success'))
          this.init()
          this.$emit('close', false, true)
        } else {
          this.$toastr.error(message, this.translations('common.error'))
        }
      } catch (error) {}
      this.isLoading = false
    },
    close () {
      this.init()
      this.$emit('close', false)
    }
  }
}
</script>

<style scoped>
.input-title-document {
  border-color: #9d9e9d;
}

.input-title-document:hover {
  border-color: unset;
}

.position-relative {
  position: relative;
}
</style>
